export default "/assets/website/images/choco_bg.webp?2f57e3319becc19898f1eb34dfdf0e19";